import React from "react";
import Button from "@material-ui/core/Button";
import { ValidatorForm, TextValidator } from 'react-material-ui-form-validator';
import MuiAlert from "@material-ui/lab/Alert";
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import Copyright from "../../Components/Copyright";
import Axios from "axios";
import useAuth from "Hooks/useAuth";
import useError from "Hooks/useError";
import { message } from "constants/message";
import googleAnalytics from "fuction/googleAnalytics";

const useStyles = makeStyles((theme) => ({
  title: {
    fontSize: "2.5em",
    color: "#556cd6",
  },
  paper: {
    marginTop: theme.spacing(8),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  wrapper: {
    margin: theme.spacing(1),
  },
  expiredWrapper: {
    margin: theme.spacing(5),
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    marginTop: theme.spacing(2),
  },
  toast: {
    width: "100%",
  },
  messsageWrapper: {
    marginTop: theme.spacing(1),
  },
}));

export default function ResetPasswordForm(props) {
  const auth = useAuth();
  const [tokenExpired, setTokenExpired] = React.useState(false);
  const [mail, setMail] = React.useState("");
  const [new_password, setNewPassword] = React.useState("");
  const [new_password_confirm, setNewPasswordConfirm] = React.useState("");
  const [user, setUser] = React.useState({});
  const [token, setToken] = React.useState(props.location.pathname.match(/token=(.+)&/)[1]);

  React.useEffect(() => {
    // タイトル変更
    document.title = "Buzz Finder - パスワードリセット";

    stateError.initialize();

    // トークンの有効期限チェック
    tokenCheck();
  }, []);

  React.useEffect(() => {
    if (!token || !user.account_id) return;

    // ログインユーザ詳細を取得
    Axios({
      method: "POST",
      url: `config/${user.account_id}/account`,
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: {
        "attrs": [
          "contract_type",
          "options",
        ]
      },
    }).then(result => {
      user.contract_type = result.data.data.contract_type;
      user.options = result.data.data.options;

      auth.login({
        user: user,
        token: token,
      });

      // ログインユーザのプランにより遷移先を振り分け
      if (result.data.data.contract_type != "ruby") {
        props.history.push("/dashboard?status=201");
      } else {
        props.history.push("/media/dashboard?status=201");
      }
    }).catch(errors => {
      const isError = true;
      let errorMsg = messages.signIn.authorization;
      stateError.dispatch({
        type: "set",
        payload: {
          isError: isError,
          errorMsg: errorMsg,
        },
      });
    });
  }, [token]);

  React.useEffect(() => {
    googleAnalytics(props.match.url, auth.state.user.account_id);
  }, [props.match.url]);

  const tokenCheck = async (e) => {
    // トークンの有効期限チェック
    Axios.defaults.baseURL = process.env.REACT_APP_API_ENDPOINT;
    Axios.defaults.headers.Authorization = `Bearer ${token}`;

    await Axios({
      method: "GET",
      url: "authentication/reset_password",
    }).then((data) => {
      return;
    }).catch(errors => {
      console.error("request err", errors);
      console.error("errors.response", errors.response);
      switch (errors.response.status) {
        case 401:
          window.location = '/?status=401';
          break;
        case 403:
          setTokenExpired(true);
          break;
        default:
          break;
      }
      throw errors;
    });
  }

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      Axios.defaults.baseURL = process.env.REACT_APP_API_ENDPOINT;
      Axios.defaults.headers.Authorization = `Bearer ${token}`;

      await Axios({
        method: "PUT",
        url: "authentication/reset_password",
        data: {
          _method: "PUT",
          email: mail,
          password: new_password,
        },
      }).then((result) => {
        setUser(result.data.data.user);
        setToken(result.data.data.bearer_token);
      });
    } catch (errors) {
      stateError.dispatch({
        type: "set",
        payload: {
          isError: true,
          errorMsg: messages.validation.common,
        },
      });
    }
  };

  const classes = useStyles();
  const stateError = useError();
  const messages = message();

  // パスワード入力形式確認用バリデーションを追加
  ValidatorForm.addValidationRule('checkPassword', (value) => {
    if (!value) return true; 
    // パスワードの正規表現
    //   (?=.*?[\u0021-\u002f\u003a-\u0040\u005b-\u0060\u007b-\u007e]) # lookahead punctuations
    //   (?=.*?[\u0030-\u0039])                                        # lookahead digits
    //   (?=.*?[\u0041-\u005a])                                        # lookahead upper case alphabets
    //   (?=.*?[\u0061-\u007a])                                        # lookahead lower case alphabets
    //   [\u0021-\u007e]{8,32}                                         # 8 to 32 of ascii printables
    const regexp = /^((?=.*?[\u0021-\u002f\u003a-\u0040\u005b-\u0060\u007b-\u007e])(?=.*?[\u0030-\u0039])(?=.*?[\u0041-\u005a])(?=.*?[\u0061-\u007a])([\u0021-\u007e]{8,32}))$/;

    if (!regexp.test(value)) {
      return false;
    } else {
      return true;
    }
  });

  ValidatorForm.addValidationRule('isPasswordMatch', (value) => {
    if (value !== new_password) {
        return false;
    }
    return true;
  });

  const onClickSigninButton = () => {
    props.history.push(`/`);
  };

  const onError = () => {
    stateError.dispatch({
      type: "set",
      payload: {
        isError: true,
        errorMsg: messages.validation.common,
      },
    });
  };

  return (
    <Container component="main" maxWidth="xs">
      { !tokenExpired ? (
        <div className={classes.paper}>
          <h1 className={classes.title}>Buzz Finder</h1>
          <Typography component="h1" variant="h5">
            パスワードリセット
          </Typography>

          <Typography component="p" variant="p" className={classes.wrapper}>
            登録しているメールアドレスと新しいパスワードを入力してください。
          </Typography>
          <ValidatorForm
            className={classes.form}
            onSubmit={handleSubmit}
            onError={onError}
            method="post"
          >
            <TextValidator
              variant="outlined"
              margin="normal"
              fullWidth
              id="email"
              label="メールアドレス*"
              name="email"
              autoFocus
              value={mail}
              onChange={(event) => {
                setMail(event.target.value);
              }}
              validators={['required', 'isEmail']}
              errorMessages={[
                messages.validation.required,
                messages.validation.isEmail,
              ]}
            />
            <TextValidator
              variant="outlined"
              margin="normal"
              fullWidth
              id="new_password"
              label="新しいパスワード*"
              name="new_password"
              autoFocus
              autoComplete="new-password"
              value={new_password}
              type="password"
              onChange={(event) => {
                setNewPassword(event.target.value);
              }}
              validators={['required', 'checkPassword']}
              errorMessages={[
                messages.validation.required,
                messages.validation.isPasswordRegexp
              ]}
            />
            <TextValidator
              variant="outlined"
              margin="normal"
              fullWidth
              id="new_password_confirm"
              label="新しいパスワード（再入力）*"
              name="new_password_confirm"
              autoFocus
              value={new_password_confirm}
              type="password"
              onChange={(event) => {
                setNewPasswordConfirm(event.target.value);
              }}
              validators={['required', 'isPasswordMatch']}
              errorMessages={[
                messages.validation.required,
                messages.validation.isPasswordMatch,
              ]}
            />
            {stateError.state.isError && (
              <div className={classes.messsageWrapper}>
                <MuiAlert
                  elevation={6}
                  variant="filled"
                  severity="error"
                  className={classes.toast}
                >
                  {stateError.state.errorMsg}
                </MuiAlert>
              </div>
            )}
            <Button
              type="submit"
              fullWidth
              variant="contained"
              color="primary"
              className={classes.submit}
            >
              送信する
            </Button>
          </ValidatorForm>
        </div>
      ) : (
        <div className={classes.paper}>
          <Avatar className={classes.avatar}>
            <LockOutlinedIcon />
          </Avatar>
          <Typography component="h1" variant="h5">
            パスワードリセット
          </Typography>

          <Typography component="p" variant="p" className={classes.expiredWrapper}>
            {messages.signIn.passwordResetExpired}
          </Typography>
          <Button
            variant="contained"
            color="primary"
            // size="small"
            // startIcon={<CommentIcon />}
            onClick={() => onClickSigninButton()}
          >
            ログインへ
          </Button>
        </div>
      )}
      <Box mt={8}>
        <Copyright />
      </Box>
    </Container>
  );
}
